import React, { createContext, useEffect, useState } from "react";
import ApiService from "../_services/ApiService";
import Config from "../_config/config";

interface AppPropertiesType {
  useCacheMethod: boolean | undefined;
}

interface AppPropertiesContextType {
  appProperties: AppPropertiesType;
  addAppProperties: () => void;
  isUsingCacheMethod: () => boolean;
  isLoading: boolean;
}

export const AppPropertiesContext = createContext<AppPropertiesContextType>({
  appProperties: {} as AppPropertiesType,
  addAppProperties: () => {},
  isUsingCacheMethod: () => false,
  isLoading: true,
});

interface Props {
  children: React.ReactNode;
}

export const AppPropertiesProvider: React.FC<Props> = ({ children }) => {

  const [appProperties, setAppProperties] = useState<AppPropertiesType>({
    useCacheMethod: false,
  });

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchInitData = async()=>{
    try{
      const response = await ApiService.initSync();
      const initData = response.data.data;

      localStorage.setItem("initData", JSON.stringify(initData));

    }catch(err){
      console.log(err);
    }
  }

  useEffect(()=>{
    const fetchAllData = async()=>{
      document.title = `${Config.tenantDisplayName} | Home`;
      setIsLoading(true);
      await fetchInitData();
      setIsLoading(false);
    }

    fetchAllData();
  },[])

  const addAppProperties = () => {
    setAppProperties({} as AppPropertiesType);
  };

  const isUsingCacheMethod = () => {
    const cacheDetails = appProperties.useCacheMethod;

    if (cacheDetails === true) return true;

    return false;
  };

  const value = {
    appProperties,
    addAppProperties,
    isUsingCacheMethod,
    isLoading
  };

  return (
    <AppPropertiesContext.Provider value={value}>
      {children}
    </AppPropertiesContext.Provider>
  );
};
